
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Drawer from '@/components/app/Drawer.vue';
import TopAccountMenu from '@/components/app/TopAccountMenu.vue';

@Component({
    components: {
        TopAccountMenu,
        Drawer,
    },
})
export default class TopNavBar extends Vue {
    @Prop({ type: String, required: true })
    title!: string;

    @Getter('isLoggedOn')
    readonly isLoggedOn!: boolean;

    protected isDrawer = false;
    protected permanent = true;
    protected showExpnadbtn = false;

    mounted() {
        let x = window.matchMedia('(max-width: 768px)');
        this.handleWindowWidth(x);
        x.addListener(this.handleWindowWidth);
    }

    handleWindowWidth(x: any) {
        if (x.matches) {
            this.permanent = false;
            this.showExpnadbtn = true;
        } else {
            this.permanent = true;
            this.showExpnadbtn = false;
        }
    }

    toggleDrawer(val: boolean) {
        this.isDrawer = val;
    }

    get hideControls() {
        return !this.isLoggedOn || (this.$route.name && this.$route.name.startsWith('account-'));
    }

    get hideSideControls() {
        return !this.isLoggedOn || this.$route.name === 'login';
    }
}
